import { DELETE, GET, POST } from '@/api/http';
import { END_POINTS } from '@/constants/endPoints';
import type { ILoginFormValues } from './utils';
import type { ILoginRequest, ILoginResponse, IMeResponse, ISignOutResponse } from './types';

export const loginService = (values: ILoginFormValues): Promise<ILoginResponse> =>
  POST<ILoginRequest, ILoginResponse>(END_POINTS.signIn, {
    session: { login: values.login.trim(), password: values.password },
  });

export const meService = (): Promise<IMeResponse> => GET<IMeResponse>(END_POINTS.me);

export const signOutService = (): Promise<ISignOutResponse> =>
  DELETE<ISignOutResponse>(END_POINTS.signOut);
